import dayjs from "dayjs"
import {MDBCardBody, MDBCardText, MDBCol, MDBRow} from "mdbreact"
import {CustomPrice} from "../../containers/CustomPrices/customPricesSlice"
import ActiveSwitch from "./activeSwitch"
import CPCustomers from "./cpCustomers"
import DaysSection from "./daysSection"
import CPTestPackages from "./cpTestPackages"
const PricingBody = ({customPrice}: {customPrice: CustomPrice}) => {
    const customHr = <hr className="mt-0 mb-0" />

    return (
        <MDBCardBody className="p-3">
            <div className={!customPrice.active ? "k-disabled" : ""}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <MDBCardText
                        style={{
                            width: "100%",
                        }}
                        className="ps-0 mb-0 me-1 clip-text font-weight-bold text-muted"
                        title={customPrice.customPricingName}
                    >
                        {customPrice.customPricingName}
                    </MDBCardText>
                </div>
                {customHr}
                <MDBRow className=" pt-2" style={{height: "150px"}}>
                    <MDBCol className="col-12">
                        <div className="font-weight-bold pb-1 text-muted">Test packages</div>
                        <CPTestPackages customPrice={customPrice} />
                    </MDBCol>
                </MDBRow>

                <MDBRow className="pt-2" style={{height: "150px"}}>
                    <MDBCol className="col-12">
                        <div className="font-weight-bold pb-1 text-muted ">Customers</div>
                        <CPCustomers customPrice={customPrice} />
                    </MDBCol>
                </MDBRow>
                <div className="">
                    <div className="font-weight-bold pb-1 pt-2 text-muted">Lane Fee</div>
                    <DaysSection customPrice={customPrice} />
                </div>
            </div>
            <ActiveSwitch customPrice={customPrice} />
            {customHr}
            <div>
                <MDBRow className={`${!customPrice.active && "k-disabled"}`}>
                    <MDBCol>
                        <MDBRow>
                            <div
                                className="pt-2 pb-2 d-flex"
                                title={dayjs(customPrice.updatedDate).format("DD/MM/YYYY HH:mm")}
                            >
                                <div className="text-muted">
                                    Last updated<>&nbsp;</> {customPrice.active}
                                </div>
                                <div> {dayjs(customPrice.updatedDate).format("DD/MM/YYYY HH:mm")}</div>
                            </div>
                        </MDBRow>
                        <MDBRow>
                            <div className="d-flex">
                                <div className="text-muted">
                                    By<>&nbsp;</>
                                </div>
                                <div className="text-overflow-wrap" title={customPrice.updatedBy.toUpperCase()}>
                                    {customPrice.updatedBy}
                                </div>
                            </div>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
            </div>
        </MDBCardBody>
    )
}

export default PricingBody
